import Vue from 'vue'
import ScrollView from 'vue-scrollview'

Vue.use(ScrollView)
